import React, { ChangeEvent } from "react";
import { Updater } from "use-immer";

import { IgSwitch, IgTextField } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import { IExperienceDashboardFilters } from "../../store/types/dashboardFilters";

interface ZScoreFilterProps {
  isZScoreEnabled: boolean;
  maxZScore: string | number | null;
  setDialogFilters: Updater<IExperienceDashboardFilters>;
  onBooleanFilterChange: (
    checked: boolean,
    filterKey: "isTestOrdersOnly" | "isZScoreEnabled"
  ) => void;
}
export const ZScoreFilter = ({
  isZScoreEnabled,
  maxZScore,
  setDialogFilters,
  onBooleanFilterChange,
}: ZScoreFilterProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onBooleanFilterChange(event.target.checked, "isZScoreEnabled");
  };
  return (
    <Grid container item direction={"row"} columnSpacing={1}>
      <Grid item>
        <IgTextField
          sx={{ width: "65px" }}
          variant={"outlined"}
          value={!isZScoreEnabled ? "9999" : maxZScore}
          inputProps={{
            min: 0,
            inputMode: "numeric",
            pattern: "^[0-9][\\.\\d]*(,\\d+)?$",
          }}
          disabled={!isZScoreEnabled}
          type={"text"}
          onChange={(e) => {
            if (e.target.validity.valid) {
              setDialogFilters((draft) => {
                draft.maxZScore = e.target.value;
                return draft;
              });
            }
          }}
        />
      </Grid>
      <Grid item>
        <IgSwitch
          checked={isZScoreEnabled}
          onChange={handleChange}
          inputProps={{ "aria-label": "controlled" }}
        />
      </Grid>
    </Grid>
  );
};
